import {
	createInteractionMetric,
	MORE_ACTIONS_DROPDOWN_INTERACTION,
} from '@confluence/browser-metrics';

export const MORE_ACTIONS_DROPDOWN_METRIC = createInteractionMetric({
	key: MORE_ACTIONS_DROPDOWN_INTERACTION,
});
